export default "/imgs/investigation-08-mob.png"